// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Ensure your index.css file exists
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // Only if you're using routing

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter> {/* Wrap the app in BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
